<template>
    <v-dialog v-model="open" max-width="600px" persistent>
      <v-card>
        <v-card-title>Send SMS</v-card-title>
        <v-card-text><v-row><v-col cols="12">Sending SMS to {{ phoneNumber }}</v-col></v-row></v-card-text>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select v-model="smsTemplate" label="Templates" :error-messages="smsError" item-text="name" item-value="id" :items="SMSTemplates" @change="preview" dense outlined hide-details></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="previewSMSContent" label="SMS Preview" placeholder outlined :readonly="true"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small :disabled="saving" :loading="saving" @click="save">Send</v-btn>
          <v-btn color="primary" outlined small :disabled="saving" @click="closeDialog">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    smsTemplate: { required },
  },

  props: {
    open: Boolean,
    close: Function,
    account: Number,
    product: Number,
    phoneNumber: String,
    kind: String,
    sub_kind: String,
  },

  data: () => ({
    smsTemplate: null,
    saving: false,
  }),

  computed: {
    ...mapState("sms", ["SMSTemplates" ,"previewSMSContent"]),
    smsError() {
      const errors = [];
      if (!this.$v.smsTemplate.$dirty) return errors;
      !this.$v.smsTemplate.required && errors.push("Sms template is required");
      return errors;
    },
  },

  watch: {
    open(open) {
      if (open) {
        this.loadSMSTemplates({kind: this.kind.toUpperCase(), sub_kind: this.sub_kind.toUpperCase()});
      }
    }
  },

  methods: {
    ...mapActions("sms", ["loadSMSTemplates", "previewSMSTemplate", "sendSMS"]),
    ...mapActions("alerts", ["setAlert"]),

    async preview() {
      this.$v.smsTemplate.$touch();
      this.previewSMSTemplate({instance_id: this.kind==='account' ? this.account : this.product, template_id: this.smsTemplate, kind: this.kind});
    },

    async save() {
      this.$v.smsTemplate.$touch();
      if(!this.$v.$invalid) {
        this.saving = true;
        try {
          await this.sendSMS({instance_id: this.account, template_id: this.smsTemplate, kind: this.kind});
          this.saving = false;
          this.setAlert({type: 'success', message: `Sent SMS to ${this.phoneNumber} Successfully.`});
          this.closeDialog();
        } catch(error) {
            this.saving = false;
            this.setAlert({type: 'error', message: `Sent SMS to ${this.phoneNumber} failed!`});
        }
      }
    },

    closeDialog() {
      this.clearData();
      this.close();
      this.$v.$reset();
    },

    clearData() {
      this.sms = "";
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
